// extracted by mini-css-extract-plugin
export default {"shell":"Layout_shell__-FN-h","main":"Layout_main__JTyR6"};